import type { InferClientOutputs } from '@orpc/client'
import type { RouterClient } from '@orpc/server'
import type { RouterUtils } from '@orpc/tanstack-query'
import { createORPCClient } from '@orpc/client'
import { RPCLink } from '@orpc/client/fetch'
import { createIsomorphicFn, createMiddleware } from '@tanstack/react-start'

import type { router } from '@acme/core'

import { getToken } from './auth'

export const getApiBaseUrl = createIsomorphicFn()
  .server(() => process.env.API_BASE_URL)
  .client(() => import.meta.env.VITE_API_BASE_URL)

export const getORPCClient = (): RouterClient<typeof router> => {
  const url = `${getApiBaseUrl()}/rpc`
  const link = new RPCLink({
    url,
    headers: () => {
      const token = getToken()
      return {
        Authorization: token ? `Bearer ${token}` : undefined
      }
    }
  })
  return createORPCClient(link)
}

export const orpcMiddleware = createMiddleware({ type: 'function' }).server(
  ({ next }) => {
    return next({ context: { orpc: getORPCClient() } })
  }
)

export type Outputs = InferClientOutputs<ReturnType<typeof getORPCClient>>

export type ORPCClient = RouterUtils<ReturnType<typeof getORPCClient>>
